// extracted by mini-css-extract-plugin
export default {"fallback":"ErrorBoundary-module__fallback--gsUzn"};